// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3ypyz","content":"styles_content__82QX5","selectAll":"styles_selectAll__2ov5w"};